import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import foto1 from "../immaginiDino/carousel/foto1.png";
import foto2 from "../immaginiDino/carousel/foto2.jpeg";
import foto3 from "../immaginiDino/carousel/foto3.jpeg";
import foto4 from "../immaginiDino/carousel/foto4.jpeg";
import foto5 from "../immaginiDino/carousel/foto5.jpeg";
import foto6 from "../immaginiDino/carousel/foto6.jpeg";
import foto7 from "../immaginiDino/carousel/foto7.jpeg";
import foto8 from "../immaginiDino/carousel/foto8.jpeg";

const CarouselComponent = () => (
    <div className="carousel-container" style={{ position: 'relative', width: '100%', height: '400px', touchAction: 'pan-y' }}>
        <Carousel
            autoPlay
            infiniteLoop
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            interval={3000}
            transitionTime={500}
            stopOnHover={false}
            showArrows={false}
            swipeScrollTolerance={5}
            preventMovementUntilSwipeScrollTolerance={true}
        >
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 1"
                    src={foto1}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 2"
                    src={foto2}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 3"
                    src={foto3}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 4"
                    src={foto4}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 5"
                    src={foto5}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 6"
                    src={foto6}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 7"
                    src={foto7}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
            <div style={{ width: '100%', height: '100%' }}>
                <img
                    alt="Immagine 8"
                    src={foto8}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </div>
        </Carousel>
    </div>
);

export default CarouselComponent;
